import { render, staticRenderFns } from "./attributesList.vue?vue&type=template&id=7c94c766"
import script from "./attributesList.vue?vue&type=script&lang=js"
export * from "./attributesList.vue?vue&type=script&lang=js"
import style0 from "./attributesList.vue?vue&type=style&index=0&id=7c94c766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports